import { defineStore } from "pinia";

export const useEvaluationPerformanceCandidateStore = defineStore('evaluationPerformanceCandidate', {
    state: () => ({
        evaluationPerformanceCandidate: {},
        evaluationPerformanceCandidates: [],
    }),
    actions: {
        setEvaluationPerformanceCandidate(evaluationPerformanceCandidate) {
            this.evaluationPerformanceCandidate = evaluationPerformanceCandidate
        },
        setEvaluationPerformanceCandidates(evaluationPerformanceCandidates) {
            this.evaluationPerformanceCandidates = evaluationPerformanceCandidates
        },
        addEvaluationPerformanceCandidate(evaluationPerformanceCandidate) {
            this.evaluationPerformanceCandidates.unshift(evaluationPerformanceCandidate)
        },
        updateEvaluationPerformanceCandidate(evaluationPerformanceCandidate) {
            let index = this.evaluationPerformanceCandidates.findIndex(cl => cl.id === evaluationPerformanceCandidate.id)
            this.evaluationPerformanceCandidates.splice(index, 1, evaluationPerformanceCandidate)
        },
        deleteEvaluationPerformanceCandidate(evaluationPerformanceCandidate) {
            let index = this.evaluationPerformanceCandidates.findIndex(cl => cl.id === evaluationPerformanceCandidate.id)
            this.evaluationPerformanceCandidates.splice(index, 1)
        },
    },
});